export function init($name) {
    const elem = $($name);

    if (!elem.length) {
        return;
    }

    elem.click(function(e) {
        if (!$(e.target).is('a') && !$(e.target).parent().is('a') && !$(e.target).is('button') && !$(e.target).parent().is('button')) {
            e.preventDefault();

            elem.not(this).removeClass('is-active');

            $(this).toggleClass('is-active');
        }
    });
}

export function parent($name) {
    const elem = $($name);

    if (!elem.length) {
        return;
    }

    elem.click(function(e) {
        if (!$(e.target).is('a') && !$(e.target).parent().is('a') && !$(e.target).is('button') && !$(e.target).parent().is('button')) {
            e.preventDefault();

            elem.not(this).parent().removeClass('is-active');

            $(this).parent().toggleClass('is-active');
        }
    });
}
